import React from 'react';
import Image, { ImageProps } from 'next/image';
import styled from 'styled-components';

const BackgroundImage = (props: ImageProps) => (
  <Wrapper>
    <StyledBackgroundImage alt="" {...props} />
  </Wrapper>
);

const Wrapper = styled.div`
  pointer-events: none;
`;

const StyledBackgroundImage = styled(Image)`
  z-index: -1;
  pointer-events: none;
`;

export default BackgroundImage;
